<template>
  <div>
Forget Password Page
  </div>
</template>

<script>
export default {
  name: 'ForgetPassword'
}
</script>
